import { render, staticRenderFns } from "./FormEndorseModal.vue?vue&type=template&id=c1668ed6"
import script from "./FormEndorseModal.vue?vue&type=script&lang=js"
export * from "./FormEndorseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports